import React, {useEffect, useMemo, useState} from 'react';
import EStyleSheet from "react-native-extended-stylesheet";
import {dbTimeFormat, isMobile} from "../../../../../../../services/Helpers";
import {HStack, VStack, Text as NBText} from "native-base";
import {t} from "../../../../../../../services/i18n";
import {useDispatch, useSelector} from "react-redux";
import {toggleScheduleLoader, toggleSuccessFlag, updateScheduleSetting} from "../../../../../../../redux/ScheduleSlice";
import AppText from "../../../../../../common/AppText";
import {Colors} from "../../../../../../../styles/Colors";
import DropDownMenu from "../../../../../../common/DropDownMenu";
import {GlobalStyleAttributes, WebGlobalStyles} from "../../../../../../../styles/GlobalStyles";
import SharedTimepicker from "../../../../../../common/SharedTimepicker";
import moment from "moment";
import FormInput from '../../../../../../common/FormInput';
import {Radio, Space} from "antd";
import {AVAILABILITY_REVEAL_TIME, CONFIRMATION_SETTINGS} from "../../../../../../../services/ConstHelper";
import {fetchApi} from "../../../../../../../services/HTTP";
import {updateBox} from "../../../../../../../redux/boxSlice";
import {store} from "../../../../../../../redux/store";

const AvailabilityRevealTime = (props) => {
    const { constantPadding, values, touched, errors, setFieldValue, setFieldTouched } = props;
    const shouldSave = useSelector((state) => state.schedule.settingsSaveFlag);
    const box = useSelector((state) => state.box.box);
    const availabilityRevealTimeSettings = useSelector(state => state.box.box.settings?.[AVAILABILITY_REVEAL_TIME])
    const [selectedOption, setSelectedOption] = useState(values.availabilityReveal.revealTime ? 'setDate' : 'showAll');
    const dispatch = useDispatch()
    const mobile = isMobile
    const fontSize = GlobalStyleAttributes.fonts.standard16

    const days = useMemo(() => {
        const items = [t('sunday'), t('monday'), t('tuesday'), t('wednesday'), t('thursday'), t('friday'), t('saturday')]
        return items.map((item, i) => ({id: i, name: item}))
    }, []);

    console.log('values',values)

    useEffect(() => {
        if(selectedOption === 'showAll') {
            setFieldValue('availabilityReveal.revealWeeks', 0)
            setFieldValue('availabilityReveal.revealDay', 0)
            setFieldValue('availabilityReveal.revealTime', null)
        } else if(selectedOption === 'setDate') {
            setFieldValue('availabilityReveal.revealWeeks', availabilityRevealTimeSettings?.revealWeeks ?? 0)
            setFieldValue('availabilityReveal.revealDay', availabilityRevealTimeSettings?.revealDay ?? 0)
            setFieldValue('availabilityReveal.revealTime', availabilityRevealTimeSettings?.revealTime ?? '08:00:00')
        }
    }, [selectedOption]);

    useEffect(() => {
        if(shouldSave) {
            save()
        }
    }, [shouldSave]);

    const save = async () => {
        try {
            if (mobile) {
                dispatch(toggleScheduleLoader(true));
                const setting = {prop_name: AVAILABILITY_REVEAL_TIME, properties: values.availabilityReveal}
                const res = await fetchApi(`boxes/settings`, 'POST', setting, false, true);
                dispatch(toggleScheduleLoader(false));
                dispatch(toggleSuccessFlag(true))
                dispatch(updateBox({
                    settings: {
                        ...store.getState().box.box.settings,
                        [AVAILABILITY_REVEAL_TIME]: setting.properties
                    }
                }))
            }
        }catch(error) {
            console.log('error',error)
            dispatch(toggleScheduleLoader(false));
        }
    }

    const setVal = (e, name) => {
        setFieldTouched(name);
        setFieldValue(name, e)
    }

    const renderRadioGroup = () => {
        return (
            <Radio.Group value={selectedOption} onChange={e => setSelectedOption(e.target.value)} space={'1rem'} bg={Colors.newDesign.white} p={constantPadding}>
                <Space direction="vertical">
                    <Radio value="showAll" size="sm">
                        <AppText fontSize={fontSize}>{t('showAllFutureAvailability')}</AppText>
                    </Radio>
                    <Radio value="setDate" size="sm">
                        <AppText fontSize={fontSize}>{t('selectWhenAvailability')}</AppText>
                    </Radio>
                </Space>
            </Radio.Group>
        )
    }

    const renderDayAndTimeInputs = () => {
        return (
            <>
                <AppText fontSize={fontSize}>{t('every')}</AppText>
                <DropDownMenu title={days[values.availabilityReveal.revealDay].name}
                              items={days}
                              onPress={(e) => setVal(e, 'availabilityReveal.revealDay')}
                              fontSize={fontSize}
                              showBorder={true}
                              width={'8.2rem'}
                              styleOverride={{height: '28px'}}
                />
                <AppText fontSize={fontSize}>{t('at')}</AppText>
                {values.availabilityReveal.revealTime && <VStack style={{width: '110px'}}><SharedTimepicker type={'time'} value={moment(values.availabilityReveal.revealTime, dbTimeFormat)} onChange={(e) => setVal(e.format(dbTimeFormat), 'availabilityReveal.revealTime')} inputStyle={{alignItems: 'center', height: `${EStyleSheet.value('$smallInputHeight')}px`}}/></VStack>}
            </>
        )
    }

    return (
        <VStack space={'1rem'}>
            <VStack space={'1rem'}>
                {!mobile && <AppText fontSize={fontSize}>{t('setTimeToRevealAvailabilityTxt')}</AppText>}
                {renderRadioGroup()}
            </VStack>
            {selectedOption === 'setDate' &&
            <VStack space={'1rem'}>
                <HStack space={'0.5rem'} alignItems={'center'}>
                    {renderDayAndTimeInputs()}
                </HStack>
                <NBText style={{alignItems: 'center', direction: 'inherit'}}>
                    <AppText fontSize={fontSize}>{t('revealFutureSessionsTxt')}</AppText>
                    <FormInput value={values.availabilityReveal.revealWeeks}
                               onChangeCallback={(e) => setVal(e, 'availabilityReveal.revealWeeks')}
                               containerProps={{mb: 0, marginX: '0.5rem'}}
                               numericOnly={true}
                               width={'3.5rem'}
                               status={errors.availabilityReveal?.revealWeeks && touched.availabilityReveal?.revealWeeks ? 'error' : null}
                    />
                    <AppText fontSize={fontSize}>{t('weeksAheadSinceThe')}</AppText>
                </NBText>
                {(touched.availabilityReveal?.revealWeeks && errors.availabilityReveal?.revealWeeks) && <AppText fontSize={fontSize} color={Colors.error} mediumFont>{errors.availabilityReveal.revealWeeks}</AppText>}
            </VStack>
            }
        </VStack>
    );
};

export default AvailabilityRevealTime;
